import {defineMessages} from 'react-intl';

const labels = defineMessages({
  hour: {
    defaultMessage: 'by Hour',
    description: 'Grain by hour',
    id: 'grain-hour',
  },
  day: {defaultMessage: 'by Day', description: 'Grain by day', id: 'grain-day'},
  week: {
    defaultMessage: 'by Week',
    description: 'Grain by week',
    id: 'grain-week',
  },
  month: {
    defaultMessage: 'by Month',
    description: 'Grain by month',
    id: 'grain-month',
  },
  quarter: {
    defaultMessage: 'by Quarter',
    description: 'Grain by quarter',
    id: 'grain-quarter',
  },
  year: {
    defaultMessage: 'by Year',
    description: 'Grain by year',
    id: 'grain-year',
  },
});

export const GRAIN_OPTIONS = [
  {key: 'HOUR', label: labels.hour},
  {key: 'DAY', label: labels.day},
  {key: 'WEEK', label: labels.week},
  {key: 'MONTH', label: labels.month},
  {key: 'QUARTER', label: labels.quarter},
  {key: 'YEAR', label: labels.year},
];
